import React from 'react';
import { useEffect, useState, useRef } from 'react';
//import { Link } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
//import { ProjectCard } from '../Models/ProjectCard';
import { getSettings } from '../Store/Settings';
import { getUser } from '../Store/Auth';
import { getChat } from '../Store/Chat';
import { useAppDispatch, useAppSelector } from '../Core/hooks';
import { openSocket } from '../Helpers/openSocket';

/* Quill imports are required because nested lists in editor use classes, not
   true semmantic nested lists. To get them to display correctly in view mode, 
   we must import these and apply the same class Quill does in editor mode.
   https://github.com/quilljs/quill/issues/1314
*/
import 'react-quill/dist/quill.core.css';
import 'react-quill/dist/quill.bubble.css';
import 'react-quill/dist/quill.snow.css';

function ChatEditor() {
    const settingsState = useAppSelector(getSettings);
    const userState = useAppSelector(getUser);
    const chatState = useAppSelector(getChat);
    const editorRef = useRef<ReactQuill | null>(null);
    const chatStateRef = useRef(chatState);
    const dispatch = useAppDispatch();
    //const [message, setMessage] = useState('');

    // Debounce timeout
    let typingTimeout: ReturnType<typeof setTimeout> | null = null;


    useEffect(() => {
        chatStateRef.current = chatState;
    }, [chatState]);
/*
    useEffect(() => {  
        const interval = setInterval(() => {
            if (editorRef.current?.getEditor?.()) {
                // @ts-ignore
                editorRef.current
                .getEditor()
                .getModule('toolbar')
                .addHandler('image', () => {

                const input = document.createElement('input');
                input.setAttribute('type', 'file');
                input.setAttribute('accept', 'image/*');
                input.click();

                input.onchange = () => {
                    const file = input.files?.[0];
                    if (!file) return;

                    const reader = new FileReader();
                    reader.onload = () => {
                    const base64Image = reader.result as string;
                    const quill = editorRef.current?.getEditor();
                    if (!quill || !base64Image) return;

                    // Delay insertion to ensure Quill is fully ready
                    setTimeout(() => {
                        const range = quill.getSelection(true) || { index: quill.getLength() };
                        try {
                        quill.insertEmbed(range.index, 'image', base64Image, 'user');
                        quill.setSelection(range.index + 1);
                        } catch (err) {
                        console.error('Quill insertEmbed failed:', err);
                        }
                    }, 0);
                    };
                    reader.readAsDataURL(file);
                }
                })
                clearInterval(interval);
            }
        }, 100);
        return () => clearInterval(interval);
      }, [editorRef])
      */

      useEffect(() => {
        const interval = setInterval(() => {
          if (editorRef.current?.getEditor?.()) {
            // @ts-ignore
            editorRef.current.getEditor().getModule('toolbar').addHandler('image', () => {
              const input = document.createElement('input');
              input.setAttribute('type', 'file');
              input.setAttribute('accept', 'image/*');
              input.click();
      
              input.onchange = () => {
                const file = input.files?.[0];
                if (!file) return;
      
                const reader = new FileReader();
                reader.onload = () => {
                  const img = new Image();
                  img.onload = () => {
                    const maxWidth = 600; // 400px
                    const scale = Math.min(1, maxWidth / img.width);
                    const width = img.width * scale;
                    const height = img.height * scale;
      
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    const ctx = canvas.getContext('2d');
                    if (!ctx) return;
      
                    ctx.drawImage(img, 0, 0, width, height);
                    const resizedBase64 = canvas.toDataURL('image/jpeg', 0.9); // can be image/png if preferred
      
                    const quill = editorRef.current?.getEditor();
                    if (!quill) return;
      
                    setTimeout(() => {
                      const range = quill.getSelection(true) || { index: quill.getLength() };
                      try {
                        quill.insertEmbed(range.index, 'image', resizedBase64, 'user');
                        quill.setSelection(range.index + 1);
                      } catch (err) {
                        console.error('Quill insertEmbed failed:', err);
                      }
                    }, 0);
                  };
      
                  img.src = reader.result as string;
                };
      
                reader.readAsDataURL(file);
              };
            });
      
            clearInterval(interval);
          }
        }, 100);
      
        return () => clearInterval(interval);
      }, [editorRef]);
      

      useEffect(() => {
        let editorElem: HTMLElement | null = null;
        let quillInstance: any = null; // to hold reference for cleanup
      
        const handleTextChange = () => {
            //alert("Adam");
          const quill = editorRef.current?.getEditor?.();
          if (!quill) return;
      
          const range = quill.getSelection(true);
          if (!range || range.index < 1) return;
      
          const cursorIndex = range.index;
          const textBefore = quill.getText(0, cursorIndex);
          const words = textBefore.trim().split(/\s/);
          const lastWord = words[words.length - 1];
      
          if (/^https?:\/\/\S+$/.test(lastWord)) {
            const start = cursorIndex - lastWord.length;
            setTimeout(() => {
                // @ts-expect-error
                quill.formatText({ index: start, length: lastWord.length }, { link: lastWord }, 'user');
              }, 0);
          }
        };
      
        const interval = setInterval(() => {
          const quill = editorRef.current?.getEditor?.();
          if (!quill) return;
      
          quillInstance = quill;
          editorElem = quill.root;
      
          // Attach listener
          quill.on('text-change', handleTextChange);
      
          clearInterval(interval);
        }, 100);
      
        return () => {
          clearInterval(interval);
          if (editorElem && quillInstance) {
            quillInstance.off('text-change', handleTextChange);
          }
        };
    }, [editorRef.current?.getEditor?.()]);

        useEffect(() => {
            const quill = editorRef.current?.getEditor?.();
            if (!quill) return;
        
            const editorElem = quill.root;
        
            const handlePaste = (e: ClipboardEvent) => {
            const text = e.clipboardData?.getData('text/plain');
            if (text && (text.startsWith("http://") || text.startsWith("https://"))) {
                e.preventDefault();
                const range = quill.getSelection(true);
                if (range) {
                quill.insertText(range.index, text, { link: text }, 'user');
                quill.setSelection(range.index + text.length);
                }
            }
            };
        
            editorElem.addEventListener('paste', handlePaste);
        
            // Cleanup on unmount or when editor changes
            return () => {
            editorElem.removeEventListener('paste', handlePaste);
            };
        }, [editorRef.current?.getEditor?.()]);
    /*
    useEffect(() => {
        setMessage((props.card.description));
    }, []);
    
    useEffect(() => {
        if (props.editing && editorRef && editorRef.current && editorRef.current.editor) {
            let descriptionLength = editorRef.current.editor.getLength();
            editorRef.current.editor.setSelection(descriptionLength +1,1);
        }
    }, [props.editing])
*/

    useEffect(() => {
        const interval = setInterval(() => {
        const quill = editorRef.current?.getEditor();
    
        if (quill) {
            // avoid multiple bindings
            quill.keyboard.bindings[13] = [];
            quill.keyboard.addBinding({ key: 13 }, () => {
                // alert("Enter key pressed!");
                const emptyParagraphs = quill.root.innerHTML.match(/<p>\s*<\/p>/gi);
                if (quill.root.innerHTML !== "" && quill.root.innerHTML !== "<p><br></p>" &&
                    !emptyParagraphs
                ) {
                    let channel = chatStateRef.current?.channels.find(c => c.loaded);
                    console.log(channel);
                    let socket = openSocket(dispatch, settingsState);
                    if (socket && channel) {
                        socket.emit("sendMessage", { 
                            channelId: channel._id,
                            message: quill.root.innerHTML
                        });
                        quill.setText("");
                    }
                }
                return false;
            });
    
            clearInterval(interval); // stop checking once it's bound
        }
        }, 100);
        return () => clearInterval(interval);
    }, []);


   const trackTyping = () => {
        //alert("text changed");
        let socket = openSocket(dispatch, settingsState);
        if (socket) {
            let channel = chatState.channels.find(c => c.loaded);
            if (channel) {

                socket.emit("typing", {
                    channelId: channel!._id,
                    userId: userState._id
                });
            
                if (typingTimeout) clearTimeout(typingTimeout);
                
                typingTimeout = setTimeout(() => {
                    socket.emit("stop typing", {
                    channelId: channel!._id,
                    userId: userState._id
                });
                }, 1000); // Stop typing after 1s of inactivity
            }
        }
   }
/*
   const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline'],
        ['link', 'image', 'video'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        ['code-block', 'blockquote'],
      ]
      }
    }
  };
*/
   // let project = projectState.projects.find(p => p.loaded);

                      /*
                        modules={{
                            toolbar: {
                                container: [...[
                                { 'header': '1' },
                                { 'header': '2' },
                                "underline",
                                "bold",
                                "italic",
                                "link",
                                { 'list': 'ordered' },
                                { 'list': 'bullet' },
                                { 'indent': '-1' },
                                { 'indent': '+1' }, 
                                "image",
                                "video",
                                "code-block",
                                'blockquote',
                                ]],
                            },
                            }}
                            */

    return (
        <>
            <div>
                <div className="quillChat" onClick={(e) => {e.preventDefault(); e.stopPropagation(); }}> 
                    <style>
                        {`
                            .ql-editor {
                                font-size: 12pt;
                                border-bottom: 1px solid #e2e2e2;
                                border-left: 1px solid #e2e2e2;
                                border-right: 1px solid #e2e2e2;
                                border-bottom-left-radius: 10px;
                                border-bottom-right-radius: 10px;
                            }
                            .ql-container.ql-snow {
                                border: 0px;
                            }
                            .ql-toolbar.ql-snow {
                                border-top: 1px solid #e2e2e2;
                                border-bottom: 1px solid #e2e2e2;
                                border-left: 1px solid #e2e2e2;
                                border-right: 1px solid #e2e2e2;
                                border-top-left-radius: 10px;
                                border-top-right-radius: 10px;
                                background-color: #f8f9f9;
                            }
                            .ql-editor.ql-blank {
                                border-bottom: 1px solid #efefef;
                                border-left: 1px solid #efefef;
                                border-right: 1px solid #efefef;
                                border-bottom-left-radius: 10px;
                                border-bottom-right-radius: 10px;
                            }
                        `}
                    </style>
                    <ReactQuill theme="snow"
                        ref={editorRef}
                        //value={message}
                        onChange={trackTyping} 
                        modules={{
                            toolbar: {
                                container: [...[
                                { 'header': '1' },
                                { 'header': '2' },
                                "underline",
                                "bold",
                                "italic",
                                "link",
                                { 'list': 'ordered' },
                                { 'list': 'bullet' },
                                { 'indent': '-1' },
                                { 'indent': '+1' }, 
                                "image",
                                "video",
                                "code-block",
                                'blockquote',
                                ]],
                            },
                        }}
                    />
                </div>
            </div>
        </>
    );    
}

export default ChatEditor;